import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { TableConfig } from 'src/app/interfaces/bl.interfaces';
import { CabotageEntry } from 'src/app/interfaces/cabotageBatches.interfaces';
import { ExportOutput, MembratedLetter } from 'src/app/interfaces/exportationBatches.interfaces';
import { LocationInterface, SalidaCatalogo, TranportLine } from 'src/app/interfaces/lotes.interfaces';
import printJS from 'print-js';
import { OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { MembratedLetterService } from 'src/app/_services/membratedLetter/membrated-letter.service';

interface infoSalida {
  id:         number;
  tipoSalida: number;
}
/**
 * Componente de página que lista las entradas de un lote de cabotaje, permitiendo consultarlas,
 * editarlas, eliminarlas, descargar archivos y generar cartas membretadas.
 */
@Component({
  selector: 'app-cabotaje-lote-entrada-lista',
  templateUrl: './cabotaje-lote-entrada-lista.component.html',
  styles: [
    `
    .table-header.carta {
      flex-direction: row-reverse;
    }
    .table-header.carta p {
      text-align: center;
    }
    .table-header.carta button {
      width: 150px;
      height: 50px;
      margin-left: 12px
    }
    .totales {
      width: 100%;
      padding: 0 10px 5px 0;
    }
    .table-row {
      background-color: #455660;
      color: #fff;
    }
    `
  ]
})
export class CabotajeLoteEntradaListaComponent implements OnInit {
  table_config: TableConfig = {
    tableHeads: [
      ['No. Operación', 'id'],
      ['Fecha de ingreso', 'admission_date'],
      ['Tipo de Transporte', 'transport_type_id'],
      ['Remolque', 'trailer_id'],
      ['Placas', 'tractor_plates'],
      ['Tonelaje', 'total_weight'],
      ['Checador', 'checker_name'],
      ['Operador', 'operator_name'],
      ['Línea transportista', 'transport_line']
    ],
    tableHeadsContainer: ['Detalle', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(9, minmax(100px, 1fr)) minmax(200px, auto)',
        'min-width': '1100px',
        'margin': '0',
        'padding': '0',
      },
      table_row: {
        'grid-template-columns': 'repeat(9, minmax(100px, 1fr)) minmax(200px, auto)',
        'min-width': '1100px',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(9, minmax(100px, 1fr)) minmax(200px, auto)',
        'min-width': '1100px',
        'background-color': '#455660',
        'color': '#fff',
      },
      container_icons: {
        'grid-template-columns': 'repeat(3, 1fr)',
      }
    },
    arrayFields: [
      'id',
      'admission_date',
      'transport_type_id',
      'trailer_id',
      'tractor_plates',
      'total_weight',
      'checker_name',
      'operator_name',
      'transport_line'
    ],
    iconos: [["/detail-entry", "entry_type_id", 'bi bi-eye'],["/update-entry", "entry_type_id", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id", 'bi bi-trash3']],
    mensaje: "Sin entradas asignadas.",
    filter: true,
    groupByField: 'admission_date',
    totalField: 'total_weight',
    subtotalField: 'tractor_plates',
    totals: {
      show: true,
      content: ['', '', '', '', 'Totales:', 'total', '', '', '',],
      total: 0,
    }
  };
  tipoTransporte: SalidaCatalogo[] = [];
  tipoUnidad: SalidaCatalogo[] = [];
  locations: LocationInterface[] = [];
  listTransportLine: TranportLine[] = [];
  transportList: any[] = [];
  outputs: ExportOutput[] = [];
  loader: boolean = false;
  errorOverlay: boolean = false;
  overlayCorrectDelete: boolean = false;
  isAuthorized: boolean = false;
  mensaje: string = '';
  bacthId: number = 0;
  currentEntryId: number = 0;
  entryEliminar: boolean = false;
  overlay: boolean = false;
  subtitulo: string = '';
  containerStyles = {
    'grid-template-columns': 'repeat(3, 1fr)'
  };
  movimiento: string = '';
  entryDetalle: CabotageEntry[] = [];
  archivos = {
    ticketBascula: '',
  };
  overlayError: boolean = false;
  loading: boolean = false;
  loaderOverlay: boolean = false;
  detail: boolean = false;
  tipoEntrada: number = 0;
  entriesType: TranportLine[] = [];
  originsTicket: OriginTicket[] = [];

  get entries() {
    return this.loteCabotajeService.cabotageEntriesFilter;
  }

  constructor(
    private authService: AuthService,
    private loteService: LoteService,
    private loteCabotajeService: LoteCabotajeService,
    private router: Router,
    private scaleTicketSvc: ScaleTicketService,
    private membratedLetterSvc: MembratedLetterService
  ) { }

  ngOnInit(): void {
    this.loader = true;
    const parts = this.router.url.split("/");
    this.bacthId = Number(parts[parts.length - 1]);
    forkJoin([
      this.loteCabotajeService.getListByBatchCabotageEntry(this.bacthId),
      this.loteService.getTipoTransporte(),
      this.loteService.getTipoUnidad(),
      this.loteService.getLocations(),
      this.loteCabotajeService.getListByBatchCabotageOutput(this.bacthId),
      this.loteService.getListTransportLine(),
      this.loteService.getListEntriesType(),
      this.scaleTicketSvc.getOriginsTicket(),
    ]).subscribe({
      next: ([
        entries,
        tipoTransporte,
        tipoUnidad,
        locations,
        outputs,
        listTransportLine,
        entriesType,
        originsTicket
      ]) => {
        this.tipoTransporte = this.sortArray<SalidaCatalogo>(tipoTransporte, 'description');
        this.tipoUnidad = this.sortArray<SalidaCatalogo>(tipoUnidad, 'description');
        this.locations = this.sortArray<LocationInterface>(locations, 'description');
        this.listTransportLine = this.sortArray<TranportLine>(listTransportLine, 'description');
        this.entriesType = this.sortArray<TranportLine>(entriesType, 'description');
        this.originsTicket = this.sortArray<OriginTicket>(originsTicket, 'description');
        this.outputs = [...outputs];
        if (entries.length) {
          entries = this.idToName(entries);
        }
        this.updateTotals(entries);
        entries = [...this.sortArrayDesc<CabotageEntry>(entries, 'id')];
        this.loteCabotajeService.cabotageEntries = [...entries];
        this.loteCabotajeService.cabotageEntriesFilter = [...entries];
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
  }

  /**
   * Verifica los permisos y prepara la confirmación para eliminar una entrada.
   * @param id - Identificador de la entrada a eliminar.
   */
  confirm(id: number) {
    const hasDeleteAuthorization = this.authService.hasAuthorization('cabotage', 'entries', 'delete');
    const hasMasterDeleteAuthorization = this.authService.hasAuthorization('cabotage', 'entries', 'master_delete');
    if (!hasDeleteAuthorization && !hasMasterDeleteAuthorization) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    this.currentEntryId = id;
    this.entryEliminar = true;
  }

  /**
   * Elimina la entrada seleccionada o cancela la operación, validando salidas y cartas membretadas,
   * y refrescando la lista y los totales al finalizar.
   * @param cancelar - Indicador que determina si se cancela la eliminación.
   */
  deleteSalida( cancelar: string ) {
    this.entryEliminar = false;
    if ( cancelar )
      return;
    const hasMasterDeleteAuthorization = this.authService.hasAuthorization('cabotage', 'entries', 'master_delete');
    if (this.outputs.length && !hasMasterDeleteAuthorization) {
      this.mensaje = 'Debes eliminar primero las salidas registradas';
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
      }, 2000);
      return;
    }
    const entry = this.entries.find(entry => {
      if (entry.id) {
        return entry.id == this.currentEntryId;
      }
      return false;
    });
    if (entry?.entry_type_id === 1 && this.membratedLetterSvc.areThereMembratedLetters) {
      this.mensaje = 'Entrada de transporte, solo se puede eliminar cuando no hay cartas membretadas';
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
      }, 4000);
      return;
    }
    this.loading = true;
    this.loteCabotajeService.deleteCabotageEntry(this.currentEntryId)
    .pipe(
      switchMap( _ => {
        this.loader = true;
        return this.loteCabotajeService.getListByBatchCabotageEntry(this.bacthId)
      })
    ).subscribe({
      next: entries => {
        this.loteCabotajeService.getCabotageBatch(this.bacthId)
        .subscribe({
          next: (batch) => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            if (entries.length) {
              entries = this.idToName(entries);
            }
            this.updateTotals(entries);
            entries = [...this.sortArrayDesc<CabotageEntry>(entries, 'id')];
            this.loteCabotajeService.cabotageEntries = [...entries];
            this.loteCabotajeService.cabotageEntriesFilter = [...entries];
            this.loader = false;
            this.loading = false;
            this.overlayCorrectDelete = true;
            setTimeout(() => {
              this.overlayCorrectDelete = false;
            }, 2000);
          },
          error: (e) => {
            this.loading = false;
            this.loader = false;
            this.mensaje = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.loader = false;
        this.mensaje = 'Error en el servidor al cargar las entradas, inténtelo más tarde';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Muestra el detalle o la edición de una entrada, validando permisos y reglas de negocio,
   * y cargando la información de la entrada, sus transportes y archivos.
   * @param entryInfo - Información de la entrada (identificador y tipo de salida).
   * @param accion - Acción a realizar ('detalle' o 'actualizar').
   */
  mostrarEntrada(entryInfo: infoSalida, accion: string) {
    this.tipoEntrada = entryInfo.tipoSalida || 1;
    const entry = this.entries.find(entry => {
      if (entry.id) {
        return entry.id == entryInfo.id;
      }
      return false;
    });
    if (accion === 'actualizar' && entry?.entry_type_id === 1 && this.membratedLetterSvc.areThereMembratedLetters) {
      this.mensaje = 'Entrada de transporte, solo se puede editar cuando no hay cartas membretadas';
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
      }, 4000);
      return;
    }
    if (accion === 'actualizar' && entry && entry.transport_type_id === 'No aplica.' && !entry.precinct_key) {
      this.mensaje = 'Entrada de traspaso, solo se puede editar desde la salida de traspaso';
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
      }, 4000);
      return;
    }
    if (accion === 'detalle') {
      this.subtitulo = 'Detalle de entrada';
      this.movimiento = 'detalle';
      if (!this.authService.isValidPath('cabotage', 'entries', 'consult')) {
        return;
      }
    } else {
      this.subtitulo = 'Editar entrada';
      this.movimiento = 'actualizar';
      if (!this.authService.isValidPath('cabotage', 'entries', 'update')) {
        return;
      }
    }
    this.loaderOverlay = true;
    this.overlay = true;
    this.detail = accion === 'detalle' && entry && entry.transport_type_id === 'No aplica.' && !entry.precinct_key ? true : false;
    forkJoin([this.loteCabotajeService.getCabotageEntry(entryInfo.id), this.loteCabotajeService.getCabotageTransportsByOutput(entryInfo.id), this.loteCabotajeService.getFileCabotageEntry(entryInfo.id)])
    .subscribe({
      next: ([entry, transports, file]) => {
        this.entryDetalle = [...entry];
        this.transportList = [...transports];
        this.archivos.ticketBascula = file.url || '';
        this.loaderOverlay = false;
      },
      error: (e) => {
        this.loaderOverlay = false;
        this.mensaje = 'Error en el servidor al obtener la entrada, inténtelo más tarde';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Cierra el overlay de detalle y recarga las entradas y la información del lote, actualizando los totales.
   */
  closeDetalle() {
    forkJoin([this.loteCabotajeService.getListByBatchCabotageEntry(this.bacthId), this.loteCabotajeService.getCabotageBatch(this.bacthId)])
    .subscribe({
      next: ([entries, batch]) => {
        if (entries.length) {
          entries = this.idToName(entries);
          // entries = this.fieldDate(entries);
        }
        this.updateTotals(entries);
        entries = [...this.sortArrayDesc<CabotageEntry>(entries, 'id')];
        this.loteCabotajeService.cabotageEntries = [...entries];
        this.loteCabotajeService.cabotageEntriesFilter = [...entries];      this.loteCabotajeService.loteInfoCabotage = batch[0];
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.mensaje = 'Error en el servidor al cargar las entradas, inténtelo más tarde';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      },
    });
    this.overlay = false;
  }

  /**
   * Descarga o abre el archivo asociado a una entrada.
   * @param ouputInfo - Información de la entrada cuyo archivo se descarga.
   */
  downloadFile(ouputInfo: infoSalida) {
    this.loteCabotajeService.getFileCabotageEntry(ouputInfo.id)
    .subscribe({
      next: file => {
        if (file.url) {
          window.open(file.url, '_blank');
        } else {
          this.mensaje = 'Este registro no tiene asignado un archivo';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 4000);
        }
      },
      error: (e) => {
        this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Genera la carta membretada del lote y la imprime o descarga según el tipo indicado.
   * @param type - Acción a realizar con la carta ('print' o 'download').
   */
  membratedLetter(type: string) {
    this.loading = true;
    this.loteCabotajeService.createMembratedLetter(this.bacthId)
    .subscribe({
      next: response => {
        if (response.error) {
          this.loading = false;
          this.mensaje = 'Lo sentimos no fue posible crear la carta membretada, inténtelo más tarde';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 2000);
          return;
        }
        if (type === 'print') {
          printJS({printable: response.file_base64, type: 'pdf', base64: true});
          this.loading = false;
          return;
        }
        this.loteCabotajeService.getMembratedLetter(this.bacthId)
        .subscribe({
          next: file => {
            this.loading = false;
            if (file.error) {
              this.mensaje = type === 'download' ?
              'Lo sentimos no fue posible descargar la orden de transporte, inténtelo más tarde' :
              'Lo sentimos no fue posible imprimir la orden de transporte, inténtelo más tarde';          this.errorOverlay = true;
              setTimeout(() => {
                this.errorOverlay = false;
              }, 2000);
              return;
            }
            if (type === 'download') {
              window.open(file.url, '_blank');
            } else {
              printJS({printable: file.file_base64, type: 'pdf', base64: true});
            }
          },
          error: (e) => {
            this.loading = false;
            this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Convierte los identificadores de catálogo de cada entrada en sus nombres descriptivos.
   * @param entries - Lista de entradas a transformar.
   * @returns La lista de entradas con los nombres descriptivos asignados.
   */
  idToName(entries: CabotageEntry[]) {
    return entries.map( entry => {
      const objEntryTransport = this.tipoTransporte.find( tipo => tipo.id == entry.transport_type_id);
      entry.transport_type_id = objEntryTransport?.description || 'No aplica.';
      const objEntryTrailer = this.tipoUnidad.find( tipo => tipo.id == entry.trailer_id);
      entry.trailer_id = objEntryTrailer?.description || 'No aplica.';
      const objEntryTransportLine = this.listTransportLine.find( tipo => tipo.id == entry.transport_line);
      entry.transport_line = objEntryTransportLine?.description || 'No aplica.';
      entry.checker_name = entry.checker_name || 'No aplica.';
      entry.operator_name = entry.operator_name || 'No aplica.';
      entry.tractor_plates = entry.tractor_plates || 'No aplica.';
      return entry;
    });
  }

  /**
   * Recorta las fechas de ingreso de las entradas al formato `YYYY-MM-DD`.
   * @param array - Lista de entradas cuyas fechas se formatean.
   * @returns La lista de entradas con las fechas formateadas.
   */
  fieldDate(array: CabotageEntry[]): CabotageEntry[] {
    array.forEach(element => {
      element.admission_date = element.admission_date !== null ? element.admission_date.substring(0, 10) : element.admission_date;
    });
    return array;
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Ordena un arreglo de manera descendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado de forma descendente.
   */
  sortArrayDesc<T>(array: T[], key: keyof T): T[] {
    return array.sort(function (a, b) {
      if (b[key] < a[key]) {
        return -1;
      }
      if (b[key] > a[key]) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Calcula y actualiza el total de tonelaje a partir de la lista de entradas.
   * @param entries - Lista de entradas sobre la que se calcula el total.
   */
  updateTotals(entries: CabotageEntry[]) {
    this.table_config.totals!.total = entries.reduce( (previous, current) => previous + Number(current.total_weight), 0);
  }

}
